import { Product } from '../types/product'

export const SITE_ORIGIN = 'https://seaters.coffee'
export const SITE_NAME = 'Seaters Coffee'
export const HOME_TITLE = 'Seaters Coffee — мережа кавʼярень specialty coffee у Києві'
export const HOME_DESCRIPTION =
  'Seaters Coffee — мережа кавʼярень specialty coffee у Києві з власною обсмажкою зерна. Еспресо, фільтр, випічка, сендвічі, салати та простір для зустрічі з собою.'

export const PUBLIC_PAGE_META = {
  maps: {
    title: "Кав'ярні",
    description:
      "Кав'ярні Seaters Coffee у Києві: адреси, години роботи та карта закладів specialty coffee.",
    path: '/maps',
  },
  contacts: {
    title: "Зв'яжіться з нашою командою",
    description: "Напишіть команді Seaters Coffee — питання про замовлення, кав'ярні та співпрацю.",
    path: '/contacts',
  },
  vacancies: {
    title: 'Актуальні вакансії',
    description: 'Відкриті вакансії в мережі кавʼярень Seaters Coffee у Києві.',
    path: '/vacancies',
  },
  delivery: {
    title: 'Доставка та оплата',
    description: 'Умови доставки та оплати замовлень Seaters Coffee.',
    path: '/delivery-payment',
  },
  exchange: {
    title: 'Обмін та повернення',
    description: 'Правила обміну та повернення товарів Seaters Coffee.',
    path: '/exchange',
  },
  privacy: {
    title: 'Політика конфіденційності та захисту даних',
    description: 'Політика конфіденційності та захисту персональних даних Seaters Coffee.',
    path: '/privacy-policy',
  },
  offer: {
    title: 'Публічний договір (Оферта)',
    description: 'Публічний договір оферти інтернет-магазину Seaters Coffee.',
    path: '/public-offer',
  },
} as const

export const ROBOTS_INDEX = 'index, follow'
export const ROBOTS_NOINDEX = 'noindex, follow'

export const NOT_FOUND_META = {
  title: 'Йой. Сіт знову щось наклацав',
  description: 'Онови сторінку або повернися назад — і давай почнемо все спочатку',
}

export const ERROR_META = {
  title: 'Щось пішло не так',
  description: 'Виникла несподівана помилка. Спробуй оновити сторінку або повернутися на головну',
}

export const PRODUCT_NOT_FOUND_META = {
  title: 'Товар не знайдено',
  description: 'Запитаний товар не існує або був видалений.',
}

export function shopDescription(title: string, categoryDescription?: string): string {
  const fromCategory = categoryDescription?.trim()
  if (fromCategory) return fromCategory
  return `Каталог specialty coffee Seaters: ${title.toLowerCase()}.`
}

export function absoluteUrl(path: string): string {
  if (!path || path === '/') return `${SITE_ORIGIN}/`
  return `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`
}

export function productCanonicalPath(slug: string): string {
  return `/product/${slug}`
}

/** Distinct per product: category + origin + process/roast, not a name-swap template. */
export function productTitle(product: Product): string {
  const kind = product.categoryExternalName || product.productCategory
  const place = [product.originCountry, product.originRegion].filter(Boolean).join(' ')
  const composed = [kind, place].filter(Boolean).join(' ').trim()
  return composed || product.name
}

export function productDescription(product: Product): string {
  const facts = [
    product.originCountry &&
      `Походження ${[product.originCountry, product.originRegion].filter(Boolean).join(', ')}`,
    product.processingMethod?.label && `обробка ${product.processingMethod.label}`,
    product.roastType?.label && `смаження ${product.roastType.label}`,
    product.farm && `ферма ${product.farm}`,
  ].filter(Boolean)

  const lead = facts.join(', ')
  const notes = (product.description || '').trim()
  if (lead && notes) return `${lead}. ${notes}`
  return lead || notes || product.name
}
